export default "__VITE_ASSET__c30e7e97__"